import {
    LiteTradeSelectAccountItemStyled,
    LiteTradeSelectAccountTopUpStyled,
} from './styled/LiteTradeSelectAccountStyled';
import BinIcon from '../../../../components/icon/Icon';
import { ACCOUNT_TYPES } from '../../../../app/appConstants';
import amountFormat from '../../../../utils/amountFormat';
import { Button } from 'react-bootstrap';
import { Slider, useSliderContext } from '../../../../components/Slider/Slider';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getUserSelectedAccountCode,
} from '../../../../app/appSelectors';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import { getLiteTradeAllAccountsMetrics } from '../../liteTradeSelectors';
import type { IUserAccount } from '../../../../app/types/appActions.t';
import type { TMetricParam } from '../../../../app/types/appReducer.t';
import { locationSlice } from '../../../Location/locationReducer';
import { LOCATION_NAMES } from '../../../Location/locationConstants';

interface LiteTradeSelectAccountRowProps {
    account: IUserAccount,
    handleAccountSelect: (e: React.SyntheticEvent<HTMLButtonElement>) => void,
    metricParam: TMetricParam
}

function LiteTradeSelectAccountRow(props: LiteTradeSelectAccountRowProps) {
    const { account, handleAccountSelect, metricParam } = props;
    const { getLangPath } = useLangContext();
    const { closeSlider } = useSliderContext();
    const dispatch = useDispatch();
    const selectedAccountCode = useSelector(getUserSelectedAccountCode);
    const metrics = useSelector(getLiteTradeAllAccountsMetrics);

    const handleTopUpButtonClick = useCallback((e) => {
        e.stopPropagation();
        closeSlider();
        dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.DEPOSIT }));
    }, [closeSlider, dispatch]);

    return <Slider.Row data-value={account.name} onClick={handleAccountSelect}>
        <LiteTradeSelectAccountItemStyled
            selected={account.name === selectedAccountCode}
        >
            <div className={'d-flex align-items-center'}>
                <BinIcon
                    className={'account-type-icon'}
                    name={account.type === ACCOUNT_TYPES.DEMO ? 'IcEducation' : 'IcCoinStack'}
                    size={'24px'}/>
                <div className={'d-flex flex-column'}>
                    <span>{getLangPath(`lite_version.home.${account.type === ACCOUNT_TYPES.DEMO ? 'demo' : 'real'}`)}</span>
                    <span>{metrics[account.name] ? amountFormat(metrics[account.name][metricParam], 2, '$') : ''}</span>
                </div>
                {
                    account.type === ACCOUNT_TYPES.LIVE && <LiteTradeSelectAccountTopUpStyled>
                        <Button className={'action-button'} variant={'secondary'} onClick={handleTopUpButtonClick}>
                            <BinIcon name={'IcPlus'}/>
                            <span>{getLangPath('lite_version.home.top_up')}</span>
                        </Button>
                    </LiteTradeSelectAccountTopUpStyled>
                }
            </div>
        </LiteTradeSelectAccountItemStyled>
    </Slider.Row>;
}

export default LiteTradeSelectAccountRow;
